import React from 'react';
import graphql from 'graphql';

// import ScrollAnimation from 'react-animate-on-scroll'
import Link, { navigateTo } from 'gatsby-link';
import Img from "gatsby-image";
import Content from '../components/Content.js';
import ScrollCascade from '../components/ScrollCascade'
import { isMobile } from 'react-device-detect';

export class AboutPageTemplate extends React.Component {

  render() {
    const { title, body, image, columns, columns2, team, bodyWidget, imageFile, teamImages } = this.props;

    return (
      <section className="section m-text-black m-background-red">

        <div className="container is-fluid" style={{ zIndex: 1 }}>
          <div className="columns">
            <div className="column is-12">
              <div className="home-title is-size-1-touch about-header is-unselectable">
                <h1 className="has-text-weight-bold animated-step-delay">
                  <ScrollCascade offset={50} animateIn="fadeIn" animateOut="fadeOut">
                    <span>PROPAPANDA</span>
                    <span>PROPAPANDA</span>
                    <span>PROPAPANDA</span>
                  </ScrollCascade>
                </h1>
              </div>
            </div>
          </div>

          <ScrollCascade animateIn="fadeIn" animateOut="fadeOut" initiallyVisible={bodyWidget?true:false}>
            <div className="columns is-variable column-reverse-touch is-8 is-margin-top-5-desktop">
              <div className="column">
                <div className="home-title content is-size-3 is-size-4-touch m-uc m-b">
                  {title}
                </div>
                <div className="content is-size-6">
                  { bodyWidget ? bodyWidget : <Content content={body} />}
                </div>
              </div>
              <div className="column">
                <figure className="image" style={{ padding: '0 25%', background: 'black' }}>
                  { bodyWidget ? <img src={image} className="is-2by3" /> : <Img sizes={imageFile.childImageSharp.sizes} /> }
                </figure>
              </div>
            </div>
            <div className="columns is-multiline is-variable is-8 is-margin-top-5-desktop">
              {columns.map(({ title, body }, index) => (
                <div key={index} className="column is-6">
                  <div className="home-title content is-size-3 is-size-4-touch m-uc m-b">
                    {title}
                  </div>
                  <div className="content is-size-6">
                    <Content content={body} />
                  </div>
                </div>
              ))}
            </div>
            <div className="columns is-multiline is-mobile is-margin-top-5-desktop">
              <div className="column is-12">
                <div className="home-title content is-size-3 is-size-4-touch m-uc m-b">
                  Team
                </div>
              </div>
              {team.map(({ name, position, image, contact, phone }, index) => (
                <div key={index} className="b-team-member column is-6-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
                  <figure className={"image"}>
                    { bodyWidget ? <img src={image} /> : <Img sizes={teamImages[index].childImageSharp.sizes} /> }
                  </figure>
                  <div style={{ marginTop: '1rem' }}>
                    <div className="home-title m-uc m-b is-size-3-widescreen is-size-4-desktop is-size-5-tablet is-size-6-mobile">{name}</div>
                    <div className="is-size-6 is-size-7-mobile">
                      {position}<br/>
                      <a href={`mailto:${contact}`} className="is-inline-block m-underborder">{contact}</a>
                      <br/>
                      <a href={`tel:${phone}`} className="is-inline-block m-underborder">{phone}</a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </ScrollCascade>
        </div>
      </section>
    );
  }
}

export default ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <AboutPageTemplate body={post.html} {...post.frontmatter} {...post.fields} />
  );
};

export const fragment = graphql`
  fragment aboutPage on MarkdownRemark {
    html
    fields {
      imageFile {
        childImageSharp {
          sizes(maxWidth: 800) {
            ...GatsbyImageSharpSizes_withWebp
          }
        }
      }
      teamImages {
        childImageSharp {
          sizes(maxWidth: 800, maxHeight: 1000) {
            ...GatsbyImageSharpSizes_withWebp
          }
        }
      }
    }
    frontmatter {
      title
      image
      columns {
        title
        body
      }
      team {
        name
        position
        image
        contact
        phone
      }
    }
  }
`

export const query = graphql`
  query Page($id: String!) {
    markdownRemark(id: { eq: $id }) {
      ...aboutPage
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/about-page.js